import React from "react";

function KpiCardLoadingShimmer() {
  return (
    <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100 animate-pulse">
      <div className="space-y-3">
        <div className="h-4 w-24 bg-gray-200 rounded" />
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1 space-y-2">
            <div className="h-7 w-32 bg-gray-200 rounded" />
            <div className="h-4 w-20 bg-gray-100 rounded" />
          </div>
          <div className="h-5 w-16 bg-gray-200 rounded" />
        </div>
        <div className="h-8 flex items-end gap-1">
          {Array.from({ length: 12 }).map((_, i) => (
            <div
              key={i}
              className="flex-1 bg-gray-200 rounded-t-sm"
              style={{ height: `${Math.random() * 100}%` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default KpiCardLoadingShimmer;
